var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React from 'react';
import { mapTextComponent, mapStyledProps, normalizeCol } from '@formily/antd';
import { Select as AntSelect } from 'antd';
import styled from 'styled-components';
import { isArr, FormPath } from '@formily/shared';
export * from '@formily/shared';
export var compose = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return function (payload) {
        var extra = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            extra[_i - 1] = arguments[_i];
        }
        return args.reduce(function (buf, fn) {
            return buf !== undefined ? fn.apply(void 0, __spreadArrays([buf], extra)) : fn.apply(void 0, __spreadArrays([payload], extra));
        }, payload);
    };
};
var createEnum = function (enums) {
    if (isArr(enums)) {
        return enums.map(function (item) {
            if (typeof item === 'object') {
                return __assign({}, item);
            }
            else {
                return {
                    label: item,
                    value: item
                };
            }
        });
    }
    return [];
};
export var Select = styled(function (props) {
    var _a = props.dataSource, dataSource = _a === void 0 ? [] : _a, onChange = props.onChange, others = __rest(props, ["dataSource", "onChange"]);
    var children = createEnum(dataSource).map(function (item) {
        var label = item.label, value = item.value, others = __rest(item, ["label", "value"]);
        return (React.createElement(AntSelect.Option, __assign({ key: value }, others, { title: label, value: value }), label));
    });
    return (React.createElement(AntSelect, __assign({ className: props.className }, others, { onChange: function (value, options) {
            onChange(value, isArr(options)
                ? options.map(function (item) { return (__assign(__assign({}, item), { props: undefined })); })
                : __assign(__assign({}, options), { props: undefined }));
        } }), children));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  min-width: 100px;\n  width: 100%;\n"], ["\n  min-width: 100px;\n  width: 100%;\n"])));
export var acceptEnum = function (component) {
    return function (_a) {
        var dataSource = _a.dataSource, others = __rest(_a, ["dataSource"]);
        if (dataSource) {
            return React.createElement(Select, __assign({ dataSource: dataSource }, others));
        }
        else {
            return React.createElement(component, others);
        }
    };
};
export var transformDataSourceKey = function (component, dataSourceKey) {
    return function (_a) {
        var _b;
        var dataSource = _a.dataSource, others = __rest(_a, ["dataSource"]);
        return React.createElement(component, __assign((_b = {}, _b[dataSourceKey] = dataSource, _b), others));
    };
};
export var createMatchUpdate = function (name, path) { return function (targetName, targetPath, callback) {
    if (targetName || targetPath) {
        if (targetName) {
            if (FormPath.parse(targetName).matchAliasGroup(name, path)) {
                callback();
            }
        }
        else if (targetPath) {
            if (FormPath.parse(targetPath).matchAliasGroup(name, path)) {
                callback();
            }
        }
    }
    else {
        callback();
    }
}; };
export { mapTextComponent, mapStyledProps, normalizeCol };
var templateObject_1;
